var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome02 = function SvgHome02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 56,
    viewBox: "0 0 46 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72347 9.81885H36.1358C36.9782 9.81885 37.6801 10.4775 37.6801 11.2678V53.5513C37.6801 54.3416 36.9782 55.0002 36.1358 55.0002H2.72347C1.88114 55.0002 1.1792 54.3416 1.1792 53.5513V11.2678C1.1792 10.4775 1.88114 9.81885 2.72347 9.81885Z",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3042 25.3618V33.1335",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09326 29.1812H14.3762",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0818 26.5474L25.1855 31.9481",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3562 43.6704L13.2525 49.2028",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3562 49.2028L13.2525 43.6704",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31885 37.6128H37.3986",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4297 20.6196V54.4727",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3438 44.3306H32.6266",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3438 48.5454H32.6266",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4826 25.625C24.0615 26.0202 24.0615 26.5471 24.4826 26.9422C24.9038 27.3374 25.4653 27.3374 25.8865 26.9422C26.3077 26.5471 26.3077 26.0202 25.8865 25.625C25.6057 25.2298 24.9038 25.2298 24.4826 25.625Z",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6601 31.4219C30.2389 31.817 30.2389 32.3439 30.6601 32.7391C31.0813 33.1343 31.6428 33.1343 32.064 32.7391C32.4852 32.3439 32.4852 31.817 32.064 31.4219C31.7832 31.0267 31.0813 31.0267 30.6601 31.4219Z",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31885 20.2241H37.3986",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9984 16.3073L40.923 8.37179C40.8293 8.13233 40.587 7.97168 40.3156 7.97168H16.0224C15.751 7.97168 15.5087 8.13233 15.415 8.37179L12.3396 16.3073V21.1571C12.3396 21.9906 13.0665 22.6726 13.9548 22.6726H42.3831C43.2715 22.6726 43.9984 21.9906 43.9984 21.1571V16.3073Z",
    fill: "#F5F8FC",
    stroke: "#F5F8FC",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1545 7.97158V1",
    stroke: "#F5F8FC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9984 16.3073L40.923 8.37179C40.8293 8.13233 40.587 7.97168 40.3156 7.97168H16.0224C15.751 7.97168 15.5087 8.13233 15.415 8.37179L12.3396 16.3073V21.1571C12.3396 21.9906 13.0665 22.6726 13.9548 22.6726H42.3831C43.2715 22.6726 43.9984 21.9906 43.9984 21.1571V16.3073Z",
    stroke: "#2F8BFF",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3396 16.1558H43.9984",
    stroke: "#2F8BFF",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1545 7.97158V1",
    stroke: "#2F8BFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1838 7.97158V1",
    stroke: "#2F8BFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1355 20.247C16.5815 20.247 16.9431 19.9077 16.9431 19.4892C16.9431 19.0707 16.5815 18.7314 16.1355 18.7314C15.6895 18.7314 15.3279 19.0707 15.3279 19.4892C15.3279 19.9077 15.6895 20.247 16.1355 20.247Z",
    fill: "#2F8BFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9656 20.247C19.4116 20.247 19.7732 19.9077 19.7732 19.4892C19.7732 19.0707 19.4116 18.7314 18.9656 18.7314C18.5195 18.7314 18.158 19.0707 18.158 19.4892C18.158 19.9077 18.5195 20.247 18.9656 20.247Z",
    fill: "#2F8BFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7652 20.247H22.1118C21.666 20.247 21.3042 19.9045 21.3042 19.4892C21.3042 19.074 21.666 18.7314 22.1118 18.7314H27.7652C28.2078 18.7314 28.5728 19.074 28.5728 19.4892C28.5728 19.9075 28.211 20.247 27.7652 20.247Z",
    fill: "#2F8BFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6196 20.3668C36.3162 20.3668 36.057 20.5985 36.057 20.8978C36.057 21.1971 36.3162 21.4288 36.6196 21.4288C36.923 21.4288 37.1823 21.1971 37.1823 20.8978C37.1823 20.5974 36.9229 20.3668 36.6196 20.3668ZM36.6196 21.0931C36.4936 21.0931 36.4027 20.999 36.4027 20.8978C36.4027 20.7971 36.4931 20.7025 36.6196 20.7025C36.7455 20.7025 36.8364 20.7964 36.8366 20.8975C36.8358 20.9989 36.7447 21.0931 36.6196 21.0931Z",
    fill: "#2F8BFF",
    stroke: "#2F8BFF",
    strokeWidth: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.677 19.9035L37.6769 19.9035C37.0923 19.3598 36.1459 19.3597 35.5621 19.9035C35.4911 19.9697 35.4911 20.08 35.5621 20.1462C35.6291 20.2085 35.7349 20.2085 35.8018 20.1462C36.2517 19.7271 36.9865 19.7271 37.4363 20.1462C37.4696 20.1772 37.514 20.1932 37.5567 20.1932C37.5983 20.1932 37.6421 20.1787 37.677 20.1462C37.748 20.08 37.748 19.9697 37.677 19.9035Z",
    fill: "#2F8BFF",
    stroke: "#2F8BFF",
    strokeWidth: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6204 18.6236C35.973 18.6236 35.3617 18.8591 34.9015 19.2878C34.8305 19.3539 34.8305 19.4643 34.9015 19.5304C34.9684 19.5928 35.0742 19.5928 35.1412 19.5304C35.5354 19.1632 36.06 18.9603 36.6204 18.9603C37.1808 18.9603 37.7054 19.1632 38.0996 19.5304C38.1329 19.5614 38.1773 19.5774 38.22 19.5774C38.2616 19.5774 38.3054 19.5629 38.3403 19.5304C38.4113 19.4643 38.4113 19.3539 38.3403 19.2878C37.8791 18.8581 37.2678 18.6236 36.6204 18.6236Z",
    fill: "#2F8BFF",
    stroke: "#2F8BFF",
    strokeWidth: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7605 18.9133C38.7937 18.9442 38.8382 18.9603 38.8808 18.9603C38.9225 18.9603 38.9662 18.9458 39.0011 18.9133L39.0012 18.9133L39.0037 18.9108C39.0698 18.8447 39.0697 18.7363 38.9992 18.6706C38.3628 18.0778 37.5172 17.7516 36.6198 17.7516C35.7223 17.7516 34.8758 18.0778 34.2394 18.6706C34.1684 18.7368 34.1684 18.8471 34.2394 18.9133C34.3063 18.9756 34.4121 18.9756 34.4791 18.9133C35.0495 18.3819 35.8093 18.0882 36.6198 18.0882C37.4301 18.0882 38.189 18.3818 38.7605 18.9133ZM38.7605 18.9133L38.8286 18.8401M38.7605 18.9133C38.7605 18.9133 38.7605 18.9133 38.7605 18.9133L38.8286 18.8401M38.8286 18.8401C38.8424 18.8529 38.8621 18.8603 38.8808 18.8603C38.8995 18.8603 38.9182 18.8538 38.933 18.8401H38.8286Z",
    fill: "#2F8BFF",
    stroke: "#2F8BFF",
    strokeWidth: 0.2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-02.52c93fe0.svg";
export { ForwardRef as ReactComponent };